import ListItemText from '@mui/material/ListItemText';

import { useTranslation } from '../../../../hooks';
import { RouteInfo } from '../../../../routes';
import { Box } from '../../../MuiGenerals';
import { isCurrentActiveMenuKey } from '../helper/currentActiveMenu';
import { StyledMenuItem } from '../styles/sx';

interface IMenuItemProps {
  title: string;
  routeInfo: RouteInfo;
  handleMenuItemClick: (routeInfo: RouteInfo) => void;
}

const MenuItem = (props: IMenuItemProps) => {
  const { translate } = useTranslation();
  const { title, routeInfo, handleMenuItemClick } = props;

  return (
    <Box >
      <StyledMenuItem
        selected={isCurrentActiveMenuKey(props.routeInfo.key)}
        onClick={() => handleMenuItemClick(routeInfo)}
      >
        <ListItemText>{title}</ListItemText>
      </StyledMenuItem>
    </Box>
  );
};

export default MenuItem;
